import React from 'react';
import { Facebook, Flag, Instagram, Mail, MapPin, Phone, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-950 pt-16 pb-8 border-t-4 border-pac-red text-slate-300" data-id="element-57" data-mp="32o4bucrusc7l">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58" data-mp="36pft9v0kpr4p">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-59" data-mp="36pz8v52r43fk">
          <div className="col-span-1 md:col-span-2" data-id="element-60" data-mp="3ug3etj3ewf9q">
            <div className="flex items-center gap-2 mb-6" data-id="element-61" data-mp="3ud7hnwze1umc">
              <Flag className="h-8 w-8 text-pac-gold" data-id="element-62" data-mp="37fv17ktl04a" />
              <div className="flex flex-col" data-id="element-63" data-mp="3lem0o69kenno">
                <span className="font-serif font-bold text-2xl leading-tight text-white tracking-wide uppercase" data-id="element-64" data-mp="3ldu5gwjvqrxx">
                  AZ City PAC
                </span>
                <span className="text-xs font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-65" data-mp="29ynk7hc24zcf">
                  Arizona City Political Action Committee
                </span>
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed" data-id="element-66" data-mp="3labrlvxno6qd">
              A statewide coalition protecting local control and advancing
              policies that strengthen Arizona&apos;s cities and towns.
            </p>
            <div className="flex gap-4" aria-label="Social media" data-id="element-67" data-mp="3v5df6nca90qu">
              <a href="#" aria-label="Facebook" className="bg-slate-800 p-2 rounded hover:bg-pac-blue hover:text-white transition-colors" data-id="element-68" data-mp="3q724ybi2so83">
                <Facebook className="h-5 w-5" data-id="element-69" data-mp="33e5h7zjgmr5" />
              </a>
              <a href="#" aria-label="X / Twitter" className="bg-slate-800 p-2 rounded hover:bg-pac-blue hover:text-white transition-colors" data-id="element-70" data-mp="ht3ajear5awp">
                <Twitter className="h-5 w-5" data-id="element-71" data-mp="qsq9zujx86n4" />
              </a>
              <a href="#" aria-label="Instagram" className="bg-slate-800 p-2 rounded hover:bg-pac-blue hover:text-white transition-colors" data-id="element-72" data-mp="mrwqdddihe01">
                <Instagram className="h-5 w-5" data-id="element-73" data-mp="yu7j4w3bzy0b" />
              </a>
            </div>
          </div>

          <div data-id="element-74" data-mp="13taji38d9g1y">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-75" data-mp="13sr2qpugcxpi">
              Quick Links
            </h2>
            <ul className="space-y-3" data-id="element-76" data-mp="18lkaznp4qo6c">
              <li data-id="element-77" data-mp="1clupjoqzmmwt">
                <a href="/#mission" className="hover:text-pac-gold transition-colors" data-id="element-78" data-mp="1cmdvs879zmv0">
                  Our Mission
                </a>
              </li>
              <li data-id="element-79" data-mp="1mktogflyb46m">
                <a href="/#issues" className="hover:text-pac-gold transition-colors" data-id="element-80" data-mp="1mkbjmul83hn3">
                  Key Issues
                </a>
              </li>
              <li data-id="element-81" data-mp="3ocq1jtnrom3i">
                <a href="/#leadership" className="hover:text-pac-gold transition-colors" data-id="element-82" data-mp="3od80wz5q7gfn">
                  Board of Directors
                </a>
              </li>
              <li data-id="element-83" data-mp="25oexs0w4xofq">
                <Link to="/news" className="hover:text-pac-gold transition-colors" data-id="element-84" data-mp="25nvlazp97s93">
                  News & Updates
                </Link>
              </li>
              <li data-id="element-85" data-mp="1worybkmyuspb">
                <a href="/#donate" className="text-pac-red font-bold hover:text-red-400 transition-colors" data-id="element-86" data-mp="1wpa2d3fveb7s">
                  Contribute
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-87" data-mp="2kcryfb663vgk">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-88" data-mp="2kc8g3tclv520">
              Contact
            </h2>
            <ul className="space-y-4" data-id="element-89" data-mp="2fgazrn1cdyp8">
              <li className="flex items-start gap-3" data-id="element-90" data-mp="18ynubc5v8qxs">
                <MapPin className="h-5 w-5 text-pac-gold shrink-0 mt-0.5" data-id="element-91" data-mp="18zfsmuqul2rr" />
                <span data-id="element-92" data-mp="13y9yqtlgb9gn">
                  Arizona City PAC
                  <br data-id="element-93" data-mp="2rvzk96vevtqj" />
                  Arizona
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-94" data-mp="2wmg00xmpfrg2">
                <Phone className="h-5 w-5 text-pac-gold shrink-0" data-id="element-95" data-mp="2wo0ukn90radx" />
                <span data-id="element-96" data-mp="2ivud8xu4qxcw">(602) 555-0198</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-97" data-mp="2it85oy78ohuo">
                <Mail className="h-5 w-5 text-pac-gold shrink-0" data-id="element-98" data-mp="2nuxk8nto7dni" />
                <span data-id="element-99" data-mp="3bk029ws7v8ij">info@azcitypac.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col items-center text-center" data-id="element-100" data-mp="3flttzfkfp26k">
          <div className="border-2 border-slate-700 p-4 mb-6 max-w-3xl w-full" data-id="element-101" data-mp="31m2d972j97ov">
            <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-102" data-mp="36kng7e9665h0">
              Paid for by Arizona City Political Action Committee. Not
              authorized by any candidate or candidate&apos;s committee.
            </p>
          </div>
          <p className="text-xs text-slate-500 max-w-3xl mb-4" data-id="element-103" data-mp="1v6rz3zypfmn5">
            Contributions to Arizona City Political Action Committee are not
            deductible as charitable contributions for federal income tax
            purposes. Federal law requires us to use our best efforts to collect
            and report the name, mailing address, occupation, and name of
            employer of individuals whose contributions exceed $200 in a
            calendar year.
          </p>
          <p className="text-xs text-slate-600" data-id="element-104" data-mp="13yrtidvr3zg4">
            &copy; {new Date().getFullYear()} Arizona City Political Action
            Committee. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}